import React, { useState, useEffect } from 'react';
import {Button} from "../../kit-components/Button";
import {Input}  from "../../kit-components/Input";
import {Phone} from "../../kit-components/Phone";
import InfoList from '../../kit-components/InfoList';
import PaymentsPlans from './PaymentsPlans';
import Offers from './Offers';
import styles from './info-step.module.scss';
import { useRef } from 'react';




export default function InfoStep(props) {
  const {
    plans,
    offers,
    handleChangeOffer,
    isDownPayment,
    currency,
    brandId,
    userData,
    loading,
    customStyle,
    handleDownPaymentChange,
    onSubmit,
  } = props;


  const [plan, setPlan] = useState({
    id: '',
    amount: 0,
    months: 0,
    extra: {
      categoryId: 0,
      adminFees: 0,
      financedAmount: 0,
    },
  });
  const [pastOffer, setOffer] = useState(null);
  const [data, setData] = useState({
    phone: '',
    downPayment: '0',
  });

const [agree, setAgree] = useState(false);
  useEffect(()=>{
    handleDownPaymentChange(parseInt(data.downPayment));
    setPlan({
      id: '',
      amount: 0,
      months: 0,
      extra: {
        categoryId: 0,
        adminFees: 0,
        financedAmount: 0,
      },
    });
  }, [data.downPayment])
  const handleSubmit = () => {
    onSubmit(plan, data.phone, data.downPayment);
  };
  const updateOffer = (offer)=>{
    if(!pastOffer || pastOffer !== offer.id){
      setOffer(offer.id);
      handleChangeOffer(userData.forsa_payment_key,userData.order_id,userData.integration_ids['FORSA'],offer)
    }
    else if(pastOffer === offer.id){
      setOffer(null);
      handleChangeOffer(userData.forsa_payment_key,userData.order_id,userData.integration_ids['FORSA']);
    }
    setData({...data,downPayment:0});
  }

  function isValidNumber(value) {
    // Check if the value is a number
    if (typeof value !== 'number' && isNaN(Number(value))) {
        return false;
    }

    // Parse the value to a number in case it's a string representation of a number
    const parsedValue = parseFloat(value);

    // Check if the value is negative (excluding zero)
    if (parsedValue < 0) {
        return false;
    }

    // Check if the parsed value is the same as the original value
    // This ensures that the input wasn't a text mixed with numbers
    if (parsedValue.toString() !== value.toString()) {
        return false;
    }

    return true;
}
  return (
    <div className={styles['container']}>
      <div className={styles['form']}>
        <div className={styles['signup-msg']}>
        Don’t have a Forsa Account?
          <a href ={`https://forsaegypt.com/app?o=${brandId}`}>Download app & Sign up now</a>
        </div>

        <Phone
          name={'phone'}
          value={data.phone}
          onChange={(phone)=> setData({...data,phone})}
          customStyle={customStyle.input}
        />
        {isDownPayment && ( <Input
          name="downPayment"
          placeholder="EGP"
          type="number"
          label={"Down Payment"}
          value={data.downPayment}
          onChange={(e)=>{setData({...data,downPayment:e.target.value})}}
          customStyle={customStyle.input}
        /> )}
      {!isValidNumber(data.downPayment)&& <span style={{color:"red"}}>Please enter a valid down payment amount</span>}
      </div>
      <div>
        <Offers offers={offers}  updateOffer={updateOffer} pastOffer={pastOffer}/>
      </div>

      <div>
        {plans.length>0?(<PaymentsPlans tenureList={plans} setPlan={setPlan} key={data.downPayment+pastOffer} />):"Unfortunately, This offer has no installment plans"}
      </div>

      <div>
        <InfoList
          title="Payment summary"
          list={[
            {
              key: 'Loan amount',
              value: `${plan.extra.financedAmount}`,
            },
            {
              key: 'Admin Fees',
              value: `${plan.extra.adminFees} `,
            },
          ]}
        />
      </div>

      <div className={styles['agreement-check']}>
        <input name={'agree'} type={'checkbox'} id ="agreeOnPayment" checked={agree} onChange={(e)=>setAgree(e.target.checked)}/>
        <label for="agreeOnPayment"> <p className={styles['text']} >
          I agree to pay EGP {parseInt(data.downPayment)+ parseInt(plan.extra.adminFees)}  in cash upon delivery
        </p></label>
      </div>

      <div className={styles['actions']}>
        <Button
          disabled={!(data.phone && isValidNumber(data.downPayment)  && agree && plan.id )}
          loading={loading}
          label={"Proceed"}
          onClick={handleSubmit}
          customStyle={customStyle.button}
        />
      </div>
    </div>
  );
}
